import { render, staticRenderFns } from "./JustificatifBeneficiaireTable.vue?vue&type=template&id=c2908d12"
import script from "./JustificatifBeneficiaireTable.vue?vue&type=script&lang=js"
export * from "./JustificatifBeneficiaireTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports